import { $isTextNode, ElementNode } from 'lexical';

export function $isEffectivelyEmpty(node: ElementNode): boolean {
  if (node.getChildrenSize() === 0) return true;
  return node
    .getChildren()
    .every(child => $isTextNode(child) && child.getTextContent().trim() === '');
}
